/* import __COLOCATED_TEMPLATE__ from './admin-avatar-stack.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();